module.exports = __webpack_public_path__ + "img/Progress-Report-Inspect-Medium.bbcbee32.png";